import React from 'react';
import { connect, useSelector } from 'react-redux';
import WaitingAreaBeforeCallsContent from '../components/pages/waiting-area/before-calls/content';

function WaitingAreaBeforeCallsPage(props) {
  const showBeforeCallsModal = useSelector((state) => state.modalReducer.showBeforeCallsModal);
  const beforeCallsForm = useSelector((state) => state.waitingAreaReducer.beforeCallsForm);

  return (
    <div>
      <WaitingAreaBeforeCallsContent
        waitingArea={props.waitingArea}
        beforeCallsForm={beforeCallsForm}
        showBeforeCallsModal={showBeforeCallsModal}
        updateOrView={props.updateOrView}
      />
    </div>
  );
}
export default WaitingAreaBeforeCallsPage;
